
<router-outlet role="main"></router-outlet>
<ngx-ui-loader></ngx-ui-loader>